/* tslint:disable */
/* eslint-disable */
/**
 * Strømbestilling API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status for bestilling
 * @export
 */
export const Status = {
    Ny: 'NY',
    FeiletKredittsjekk: 'FEILET_KREDITTSJEKK',
    Bekreftet: 'BEKREFTET',
    AvventerInfo: 'AVVENTER_INFO',
    AvventerSamtykke: 'AVVENTER_SAMTYKKE',
    SamtykkeFeil: 'SAMTYKKE_FEIL',
    SamtykkeAvvist: 'SAMTYKKE_AVVIST',
    SamtykkeUtlopt: 'SAMTYKKE_UTLOPT',
    Ferdig: 'FERDIG',
    ManuellBehandling: 'MANUELL_BEHANDLING',
    Feilet: 'FEILET',
    FeiletRegistrering: 'FEILET_REGISTRERING',
    Aktivert: 'AKTIVERT',
    Annullert: 'ANNULLERT',
    KundeVedBestilling: 'KUNDE_VED_BESTILLING',
    Arkivert: 'ARKIVERT'
} as const;
export type Status = typeof Status[keyof typeof Status];


export function instanceOfStatus(value: any): boolean {
    for (const key in Status) {
        if (Object.prototype.hasOwnProperty.call(Status, key)) {
            if (Status[key as keyof typeof Status] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StatusFromJSON(json: any): Status {
    return StatusFromJSONTyped(json, false);
}

export function StatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): Status {
    return json as Status;
}

export function StatusToJSON(value?: Status | null): any {
    return value as any;
}

export function StatusToJSONTyped(value: any, ignoreDiscriminator: boolean): Status {
    return value as Status;
}

